import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';
import CircleImage from '../../components/CircleImage';
import LoadingSpinner from '../../components/LoadingSpinner';

// TYPES
import { SafetyChecklistConditionSearchUserSearchResult } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface AddRecipientsModalProps {
	availableRecipients: SafetyChecklistConditionSearchUserSearchResult[];
	loading: boolean;
	loadError: string | null;
	recipientUserIds: string[];
	onAdd: (item: SafetyChecklistConditionSearchUserSearchResult) => void;
	onRemove: (userId: string) => void;
	closeModal?: closeModalType;
}

const AddRecipientsModal: React.FC<AddRecipientsModalProps> = ({
	availableRecipients,
	loading,
	loadError,
	recipientUserIds,
	onAdd,
	onRemove,
	closeModal
}) => {
	const isAdded = (id?: string) => !!(id && recipientUserIds.includes(id));

	return (
		<>
			{loading ? (
				<div className="d-flex justify-content-center p-4">
					<LoadingSpinner show={true} />
				</div>
			) : loadError ? (
				<p className="error-message">{loadError}</p>
			) : availableRecipients.length > 0 ? (
				<section className="info-section incident-form mtop-0 bg-white rounded border-grey-3 p-3 max-height-550 w-100">
					<ul>
						{availableRecipients.map((item, index) => {
							const added = isAdded(item.id);
							return (
								<li key={item.id || index} className="row-container no-hover">
									<div
										className={`row detail-row ${index === availableRecipients.length - 1 ? 'border-bottom-0' : ''}`}
									>
										<div className="col-2 pdl-0">
											<CircleImage firstName={item.name} lastName={item.name} src={item.profileImage} />
										</div>
										<div className="col-8 pdl-0">
											<div className="row detail-info center">
												<div className="col-12 pdl-0 detail-name">
													<p className="detail-name mbtom-0">{item.name}</p>
													<p className="label body-medium fw-bold text-grey-5 mbtom-0">{item.role}</p>
												</div>
											</div>
										</div>
										<div className="col-2 link-group pdr-0">
											{item.id && (
												<Button
													className="btn-text pdr-0 mtop-0 recipient-list-toggle"
													onClick={() => (added ? onRemove(item.id!) : onAdd(item))}
												>
													{added ? 'Remove' : 'Add'}
												</Button>
											)}
										</div>
									</div>
								</li>
							);
						})}
					</ul>
				</section>
			) : (
				<p className="body-medium text-grey-4">No recipients available</p>
			)}
			<div className="form-button-group mtop-24">
				<Button className="btn-primary w-100" onClick={closeModal}>
					Close
				</Button>
			</div>
		</>
	);
};

export default AddRecipientsModal;
